<app-pan-action-bar class="mb-4">
  <ol class="inline-flex items-center space-x-1 md:space-x-2">
    <li>
      <app-pan-button-group>
        <app-pan-button color="info" [fill]="view() === 'Active' ? 'filled' : 'outline'" (click)="view.set('Active')">
          Active Locations
        </app-pan-button>

        <app-pan-button color="info" [fill]="view() === 'Archived' ? 'filled' : 'outline'" (click)="view.set('Archived')">
          Archived Locations
        </app-pan-button>
      </app-pan-button-group>
    </li>
  </ol>
</app-pan-action-bar>

@if (view() === "Active") {
  <ag-grid-angular
    #locationsGrid
    [rowData]="tableLocations()"
    [columnDefs]="locationColumns"
    [gridOptions]="locationTableDef"
    [loading]="isLoading()"
    class="w-full"
  ></ag-grid-angular>
} @else {
  <ag-grid-angular
    #archivedLocationsGrid
    [rowData]="archivedLocations()"
    [columnDefs]="archiveColumns"
    [gridOptions]="archiveTableDef"
    [loading]="isLoading()"
    class="w-full"
  ></ag-grid-angular>
}

<app-pan-modal #addModal [topLevel]="false" [shouldBodyScroll]="false" size="sm">
  <div header>Add New Location</div>
  <div body>
    <app-pan-form-control>
      <app-pan-floating-label>Location Name</app-pan-floating-label>
      <input panInput [(ngModel)]="newLocationName" placeholder="Location name..." />
    </app-pan-form-control>

    <app-pan-form-control>
      <app-pan-floating-label>Location Timezone</app-pan-floating-label>
      <ng-select class="w-full mb-2" placeholder="Select timezone..." [items]="allTimezones()" [(ngModel)]="newLocationTimezone">
      </ng-select>
    </app-pan-form-control>

    <label class="text-sm">
      <input type="checkbox" panCheckbox [(ngModel)]="isNewLocationNationalAccount" />
      Is this location a national account?
    </label>
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Cancel</app-pan-button>
    <app-pan-button panModalClose color="primary" (click)="createNewLocation()" [disabled]="!newLocationName() || !newLocationTimezone()"
      >Add Location</app-pan-button
    >
  </div>
</app-pan-modal>

<app-pan-modal #mergeModal [topLevel]="false">
  <div header>Merge Locations</div>
  <div body>
    <ng-select
      class="w-full"
      placeholder="Select location to merge into..."
      [bindLabel]="'name'"
      [virtualScroll]="true"
      [items]="mergeableLocations()"
      [(ngModel)]="mergeModalLocation"
      [clearable]="false"
    ></ng-select>
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Close</app-pan-button>
    <app-pan-button panModalClose color="warning" (click)="doMerge()" [disabled]="!mergeModalLocation()">Merge</app-pan-button>
  </div>
</app-pan-modal>

<app-pan-modal #transferModal [topLevel]="false">
  <div header>Transfer Location</div>
  <div body>
    <ng-select
      class="w-full"
      placeholder="Select branch to transfer to..."
      [bindLabel]="'name'"
      [virtualScroll]="true"
      [items]="transferrableBranches()"
      [(ngModel)]="transferToBranch"
      [clearable]="false"
    ></ng-select>
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Close</app-pan-button>
    <app-pan-button panModalClose color="warning" (click)="doTransfer()" [disabled]="!transferToBranch()">Transfer</app-pan-button>
  </div>
</app-pan-modal>
